export enum DeliveryEstimateType {
    LessThan5 = 0,
    From5To20 = 1,
    From21To50 = 2,
    MoreThan50 = 3
}